<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent">
      <h5 v-show="isContactInfoEditable" class="card-title text-muted m-0">{{
          $t('contact_info')
        }}</h5>
      <h5 v-show="!isContactInfoEditable" class="card-title text-muted m-0">{{ $t('edit_contact_info') }}</h5>

      <div>

        <a href="#" v-show="!isContactInfoEditable" class="text-muted" @click.prevent="showContactInfoHide">
          <app-icon stroke-width="1" name="x-square"/>
        </a>
        <a href="#" v-show="!isContactInfoEditable" class="text-muted" @click.prevent="showContactInfoSave">
          <app-icon stroke-width="1" name="check-square"/>
        </a>

        <a href="#" v-show="isContactInfoEditable" class="text-muted" @click.prevent="showContactInfoEditable">
          <app-icon stroke-width="1" name="edit"/>
        </a>
      </div>
    </div>

    <div class="card-body">
      <div v-show="isContactInfoEditable">
        <div class="form-group mb-primary">
          <div class="form-row" v-if="personContactInfo.phone">
            <label class="text-muted col-12">
              <span v-if="personContactInfo.phone.length > 1">{{ $t('phones') }}</span>
              <span v-else>{{ $t('phone') }}</span>
            </label>
            <div class="col-12">
              <div class="d-flex justify-content-between"
                   v-for="(phoneNumber, index) in personContactInfo.phone" :key="index">
                <div>{{ phoneNumber.value }}</div>
                <div
                    :class="{'mb-2': personContactInfo.phone.length > 1 && index !== personContactInfo.phone.length - 1}">
                          <span v-if="phoneNumber.type">
                              <app-badge v-if="phoneNumber.type.class"
                                         :label="phoneNumber.type.name"
                                         :class-name="`badge-sm badge-pill badge-${phoneNumber.type.class}`"/>

                               <app-badge v-else :label="phoneNumber.type.name"
                                          :class-name="`badge-sm badge-pill badge-secondary`"/>
                          </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group mb-0">
          <div class="form-row" v-if="personContactInfo.email">
            <label class="text-muted col-12">
              <span v-if="personContactInfo.email.length > 1">{{ $t('emails') }}</span>
              <span v-else>{{ $t('email') }}</span>
            </label>
            <div class="col-12">
              <div class="d-flex justify-content-between"
                   v-for="(email, index) in personContactInfo.email" :key="index">
                <div class="text-break mr-2">
                  {{ email.value }}
                </div>
                <div
                    :class="{'mb-2': personContactInfo.email.length > 1 && index !== personContactInfo.email.length - 1}">
                      <span v-if="email.type">
                                      <app-badge v-if="email.type.class"
                                                 :label="email.type.name"
                                                 :class-name="`badge-sm badge-pill badge-${email.type.class}`"/>

                                       <app-badge v-else :label="email.type.name"
                                                  :class-name="`badge-sm badge-pill badge-secondary`"/>
                                  </span>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!isContactInfoEditable">
        <div class="form-group">
          <div class="form-row" v-if="personContactInfo.phone">
            <label class="col-12" v-if="personContactInfo.phone.length > 1">
              {{ $t('phones') }}</label>
            <label v-else class="col-12">{{ $t('phone') }}</label>
            <div class="col-12">
              <div v-for="(phoneNumber, index) in personContactInfo.phone" :key="index"
                   :class="{'mb-3': personContactInfo.phone.length > 1 && index !== personContactInfo.phone.length - 1}">
                <div class="form-row">
                  <div class="col-12 mb-1">
                    <app-input type="tel-input" v-model="phoneNumber.value"
                               :placeholder="$t('enter_phone')"/>
                    <small class="text-danger" v-if="errors['phone.'+index+'.value']">{{errors['phone.'+index+'.value'][0]}}</small>
                  </div>
                  <div class="col-10">
                    <app-input type="select"
                               list-value-field='name'
                               :list="typeList"
                               :placeholder="$t('type')"
                               v-model="phoneNumber.type_id"/>
                  </div>
                  <div class="col-2 d-flex justify-content-center align-items-center">
                    <a href="#" class="text-muted"
                       @click.prevent="deleteContactInfo('phone', index)">
                      <app-icon width="20" stroke-width="1" name="trash"/>
                    </a>
                  </div>
                </div>

              </div>
              <a href="#" class="font-size-90" @click.prevent="addMoreContactInfo('phone')">
                {{ $t('add_more') }}
              </a>
            </div>
          </div>
        </div>
        <div class="form-group mb-0">
          <div class="form-row" v-if="personContactInfo.email">
            <label class="col-12" v-if="personContactInfo.email.length > 1">
              {{ $t('emails') }}
            </label>
            <label v-else class="col-12">{{ $t('email') }}</label>

            <div class="col-12">
              <div v-for="(email, index) in personContactInfo.email" :key="index"
                   :class="{'mb-3': personContactInfo.email.length > 1 && index !== personContactInfo.email.length - 1}">
                <div class="form-row">
                  <div class="col-12 mb-1">
                    <app-input type="email"
                               :placeholder="$t('enter_email')"
                               v-model="email.value"/>
                    <small class="text-danger" v-if="errors['email.'+index+'.value']">{{generateValidationMessage(errors['email.'+index+'.value'][0],'email')}}</small>
                  </div>

                  <div class="col-10">
                    <app-input type="select"
                               list-value-field='name'
                               :list="typeList"
                               :placeholder="$t('type')"
                               v-model="email.type_id"/>
                  </div>
                  <div class="col-2 d-flex justify-content-end align-items-center">
                    <a href="#" class="text-muted"
                       @click.prevent="deleteContactInfo('email', index)">
                      <app-icon width="20" stroke-width="1" name="trash"/>
                    </a>
                  </div>
                </div>
              </div>
              <a href="#" class="font-size-90" @click.prevent="addMoreContactInfo('email')">
                {{ $t('add_more') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";

export default {
  name: "PersonContactInfo",
  props: ['personContactInfo'],
  mixins: [FormMixin],
  data() {
    return {
      isContactInfoEditable: true,
      errors:{}
    }
  },
  computed: {
    typeList() {
      return this.$store.getters.getPhoneEmailType
    },
  },
  methods: {
    generateValidationMessage(value,name){
      let message = value.split(" ");
      message[1] = name;
      return message.join(' ');
    },
    addMoreContactInfo(type) {
      if (type === 'phone') {
        this.personContactInfo.phone.push({
          'phone': {
            value: '',
            type_id: ''
          }
        });
      } else {
        this.personContactInfo.email.push({
          'email': {
            value: '',
            type_id: ''
          }
        });
      }
    },
    showContactInfoHide() {

      let phoneList = this.personContactInfo.phone.filter((item) => {
        if (item.value) {
          return true;
        }
      })
      this.personContactInfo.phone = phoneList;

      let emailList = this.personContactInfo.email.filter((item) => {
        if (item.value) {
          return true;
        }
      })
      this.personContactInfo.email = emailList;

      this.isContactInfoEditable = true
    },
    showContactInfoSave() {
      let PhoneInfoFlatArray = this.personContactInfo.phone.map(function (data) {
        return {
          'value': data.value,
          'type_id': data.type_id
        }
      });

      let EmailInfoFlatArray = this.personContactInfo.email.map(function (data) {
        return {
          'value': data.value,
          'type_id': parseInt(data.type_id)
        }
      });

      this.axiosPost({
        url: `crm/persons/contact/sync/${this.personContactInfo.id}`,
        data: {'phone': PhoneInfoFlatArray, 'email': EmailInfoFlatArray}
      }).then(response => {
        this.$toastr.s(response.data.message);
        this.errors = {}
        this.isContactInfoEditable = true;
        this.$emit('update-request')
      }).catch((error) => {
        this.errors = error.response.data.errors;
      })

    },
    showContactInfoEditable() {
      this.isContactInfoEditable = false
    },

    deleteContactInfo(type, index) {
      if (type === 'phone') {
        this.personContactInfo.phone.splice(index, 1)
      } else {
        this.personContactInfo.email.splice(index, 1)
      }
    },

  },

  mounted() {
    this.$store.dispatch('getPhoneEmailType');
  }
}
</script>


